import { AttributesFilterInput, LocalesEnum, OperationsEnum } from '../generated/operations';

export function createFilterForGlobalSearch(locale: LocalesEnum, query: string, company?: string,): AttributesFilterInput {
  const search = {name: "label", values: [query], op: OperationsEnum.Like, locale};
  const IsSensor = {name: "6084", values: ["[\"Retrofit Sensor\"]"], op: OperationsEnum.Eq, locale};
  if (!company || company && company.length === 0) {
    return {
      values: [search]
    }
  }
  return {
    values: [],
    or: [
      {
        values: [
          IsSensor,
          {...search, name: "8401", values: [`%%${company}%%`]},
          ...(query.length > 0 ? [search] : []),
        ],
      },
      {
        values: [
          {...IsSensor, op: OperationsEnum.Ne},
          {...search, name: "7687", values: [`%%${company}%%`]},
          ...(query.length > 0 ? [search] : []),
        ]
      }
    ]
  }
}
